import { render, staticRenderFns } from "./ErrorTbk.vue?vue&type=template&id=0a8df8f4&lang=pug"
import script from "./ErrorTbk.vue?vue&type=script&lang=js"
export * from "./ErrorTbk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports